import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { withRadium, DetectCompact } from "higher-order-components"
import COLOR_PALETTE from "constants/color-palette"
import { Link } from "react-router-dom"
import { NotificationsIcon } from "components"
import { NotificationType } from "containers/mymazda/navigation/notifications"
import gtmHandler from "AtomicUtils/gtmHandler"
import buttonStyles from "AtomicComponents/Button/Button.less"
import { Caption, Space, AlertIcon } from "AtomicComponents";

const NotificationsList = ({ items, compact }) => (
  <div style={{ borderTop: "1px solid " + COLOR_PALETTE.GRAY, marginTop: "4em", width: "100%", textAlign: "left" }}>
    {items && items.length ? (
      items.map(item => {
        if (!item.notificationID) return null
        return (
          <div key={item.notificationID} style={styles.item(compact)}>
            <div style={styles.left(compact)}>
              {item.notificationType === "RECALL" ? (
                <AlertIcon style={styles.icon(COLOR_PALETTE.RED)} />
              ) : (
                <NotificationsIcon style={styles.icon(COLOR_PALETTE.BLACK)} />
              )}
              <p style={styles.paragraph}>
                <NotificationType item={item} />
              </p>
              <Space />
              <Caption>{item.notificationDate}</Caption>
            </div>
            <div style={{ flex: "1 1 25%", margin: compact && item.buttonUrl ? "2em 0 0 3em" : "0" }}>
              {item.buttonUrl && item.buttonLinkText && (
                <Link to={item.buttonUrl} style={{ textDecoration: "none" }}>
                  <span
                    className={`Button ${classnames({
                      [buttonStyles.Button]: true,
                      [buttonStyles.ButtonFullWidth]: !compact,
                      [buttonStyles.ButtonWhiteOutlined]: item.notificationType !== "RECALL",
                      [buttonStyles.ButtonRed]: item.notificationType === "RECALL"
                    })}`}
                    onClick={() => {
                      gtmHandler({
                        pageCategory: "MyMazda - Notifications",
                        pageAction: `"${item.notificationType}" - clicked "${item.buttonLinkText.toUpperCase()}"`
                      })
                    }}
                  >{item.buttonLinkText}</span>
                </Link>
              )}
            </div>
          </div>
        )
      })
    ) : (
      <p style={[styles.item(compact), { justifyContent: "center", margin: "0" }]}>
        No notifications.
      </p>
    )}
  </div>
)

const styles = {
  item: compact => ({
    borderBottom: "1px solid " + COLOR_PALETTE.GRAY,
    padding: "2em 0",
    display: "flex",
    fontWeight: "200",
    flexDirection: compact ? "column" : "row"
  }),
  left: compact => ({
    flex: "1 1 75%",
    paddingLeft: "3em",
    paddingRight: compact ? "0" : "2em",
    boxSizing: "border-box",
    position: "relative"
  }),
  icon: color => ({
    position: "absolute",
    left: "0",
    top: "4px",
    width: "20px",
    height: "20px",
    fill: color
  }),
  paragraph: {
    lineHeight: "27px",
    margin: "0"
  },
  date: {
    color: COLOR_PALETTE.GRAY_DARK,
    margin: "1em 0 0",
    fontSize: "14px"
  }
}

export default withRadium(DetectCompact())(NotificationsList)

NotificationsList.propTypes = {
  compact: PropTypes.bool,
  items: PropTypes.array
}



// WEBPACK FOOTER //
// ./src/components/mymazda/notifications-list/index.jsx